import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getToken } from '@/store/actions/authenticate';
import Skeleton from '@/components/common/skeleton';
import { useHistory } from 'react-router-dom';
import { ROUTE_BEFORE_LOGIN } from '@/common/constant';

const Authenticate = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { search, origin, pathname } = window.location;
  useEffect(() => {
    dispatch(
      getToken({ search, redirect_uri: `${origin}${pathname}` }, (result) => {
        if (result) {
          history.replace(sessionStorage.getItem(ROUTE_BEFORE_LOGIN) || '/');
        }
      }),
    );
  }, []);
  return <Skeleton active />;
};

export default Authenticate;
